<div class="workforce-dashboard">
  <div class="workforce-toolbar">
    <a class="workforce-home" routerLink="/dashboard/workforce/overview">Workforce Analytics</a>
    <a class="workforce-export" routerLink="/dashboard/workforce/export" routerLinkActive="selected">Export reports</a>
  </div>
  <router-outlet></router-outlet>
  <div class="footer-note">These analytics are for HR planning and audit support only. Not automated employment decisions.</div>
</div>
